<script>
import { metaFields } from "./metaFields";
import { Validator } from "@/plugins/validator";
export default {
    name: "SelectInsuranceForm",

    data() {

        return {
            insuranceDetails: {
                customerID: this.$route.params.id,
                active: true,
            },
            errors: [],
        };
    },

    props: {

        showModal: Boolean,
        patient: Object,
        dependants: Array,
        coverTypes: Array,
        patientInsurances: Array,
        forUseInsurances: Array,
    },

    components: {

        'confirm-select-use': () => import('./ConfirmSelectForUse.vue'),
    },

    methods: {

        saveData() {

            (new Validator(this.insuranceDetails, metaFields).validate()).then(() => {
                this.errors = [];
                this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientInsuranceDetails`, this.insuranceDetails).then(response => {
                    this.insuranceDetails = { customerID: this.patient.patientid, active: true };
                    this.$root.loading = false;
                    window.Swal.fire({ type: 'success', title: response.data });
                    this.$emit('refreshData');
                }).catch(() => {
                    this.$root.loading = false;
                });
            }).catch(errors => {
                this.errors = errors;
            });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-10/12">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Edit Insurance/ Organizations Companies Details</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap">
            <div class="w-full p-1 border-b-2 border-gray-400">
                <h6 class="font-bold text-sm">PATIENT NAME: </h6>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-insurance" class="label-control">Insurance:</label>
                <v-select class="text-xs" v-model="insuranceDetails.organizationID" :options="coverTypes" label="organization" :reduce="coverType => coverType.organizationID"></v-select>
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'organizationID').length">
                    {{ errors.filter(error => error.field == 'organizationID')[0].message }}</p>
            </div>  
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-insurance" class="label-control">Insurance:</label>
                <v-select class="text-xs" v-model="insuranceDetails.organizationID" :options="coverTypes" label="organization" :reduce="coverType => coverType.organizationID"></v-select>
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'organizationID').length">
                    {{ errors.filter(error => error.field == 'organizationID')[0].message }}</p>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-dependant" class="label-control">Dependant:</label>
                <select id="grid-dependant" v-model="insuranceDetails.principalOfDependantId" class="input-control input-sm text-xs">
                    <option v-for="(dependant, idx) in dependants" :key="idx" :value="dependant.principalOfDependantId">{{ dependant.principalOfDependant }}</option>
                </select>
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'principalOfDependantId').length">
                    {{ errors.filter(error => error.field == 'principalOfDependantId')[0].message }}</p>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-member-no" class="label-control">Member No:</label>
                <input type="text" id="grid-member-no" v-model.trim="insuranceDetails.memberno" class="input-sm input-control text-xs">
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberno').length">
                    {{ errors.filter(error => error.field == 'memberno')[0].message }}</p>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-confirm-member-no" class="label-control">Confirm Member No:</label>
                <input type="text" id="grid-confirm-member-no" v-model.trim="insuranceDetails.membernoConfirmed" class="input-sm input-control text-xs">
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'membernoConfirmed').length">
                    {{ errors.filter(error => error.field == 'membernoConfirmed')[0].message }}</p>
            </div>
            <div class="md:w-1/4 sm:w-full p-2">
                <label for="grid-id-no" class="label-control">ID No:</label>
                <input type="text" id="grid-id-no" v-model.trim="insuranceDetails.memberIDNo" class="input-sm input-control text-xs">
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberIDNo').length">
                    {{ errors.filter(error => error.field == 'memberIDNo')[0].message }}</p>
            </div>
            <div class="md:w-1/5 sm:w-full p-2">
                <label for="grid-confirm-id-no" class="label-control">Confirm ID No:</label>
                <input type="text" id="grid-confirm-id-no" v-model.trim="insuranceDetails.memberIDNoConfirmed" class="input-sm input-control text-xs">
                <p class="form-text-error" v-if="errors.filter(error => error.field == 'memberIDNoConfirmed').length">
                    {{ errors.filter(error => error.field == 'memberIDNoConfirmed')[0].message }}</p>
            </div>
            <div class="md:w-1/5 sm:w-full p-2">
                <label for="grid-employer-2" class="label-control">Employer:</label>
                <input type="text" id="grid-employer-2" v-model.trim="insuranceDetails.employer" class="input-sm input-control text-xs">
            </div>
            <div class="md:w-1/6 sm:w-full p-2 pt-3">
                <label for="grid-active" class="label-control mt-5">Active <input type="checkbox" v-model="insuranceDetails.active" id="grid-active"></label>
            </div>
            <div class="md:w-1/6 sm:w-full p-1 pt-6">
                <label for="grid-select-use" class="font-semibold mr-1">Select (USE)</label> <input type="checkbox" id="grid-select-use">
            </div>
            <div class="flex justify-end w-full p-1 border-t-2">
                    <button class="btn-sm btn-info text-xs" @click.prevent="saveData"><i class="fa fa-save"></i> Record</button>
            </div>
            <div class="flex flex-col w-full">
                <div class="flex-1">
                    <h6 class="font-bold text-blue-600 text-center">Currently registered Insurances</h6>
                </div>
                <div class="flex-1">
                    <table class="table table-bordered">
                        <thead class="bg-gray-400 text-sm">
                            <tr>
                                <th>Organization</th>
                                <th>Member No</th>
                                <th>Principal Dependant</th>
                                <th>ID NO</th>
                                <th>Rebate</th>
                                <th>Active</th>
                                <th>Employer</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(patientCover, idx) in patientInsurances" :key="idx">
                                <td>{{ patientCover.organization }}</td>
                                <td>{{ patientCover.memberno }}</td>
                                <td>{{ patientCover.principalOfDependant }}</td>
                                <td>{{ patientCover.memberIDNo }}</td>
                                <td>{{ patientCover.rebate }}</td>
                                <td>{{ patientCover.active }}</td>
                                <td>{{ patientCover.employer }}</td>
                                <td>
                                    <button class="btn-sm btn-info text-xs mr-1" @click.prevent="insuranceDetails = patientCover"><i class="fa fa-edit"></i></button>
                                    <button class="btn-sm btn-primary text-xs" @click.prevent="patientCover.confirm = true"><i class="fa fa-check"></i></button>
                                </td>
                                <confirm-select-use
                                 @closeModal="patientCover.confirm = false"
                                 :cover="patientCover"
                                 :showModal="patientCover.confirm"
                                 @refreshData="$emit('refreshForUseInsurance')"
                                 ></confirm-select-use>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="flex-1">
                    <h6 class="font-bold text-blue-600 text-center">Insurance Selected for use</h6>
                </div>
                <div class="flex-1">
                    <table class="table table-bordered">
                        <thead class="bg-gray-400 text-sm">
                            <tr>
                                <th>ID</th>
                                <th>Organization</th>
                                <th>Type of Cover</th>
                                <th>Member No</th>
                                <th>Principal Dependant</th>
                                <th>ID NO</th>
                                <th>Notification No</th>
                                <th>Rebate</th>
                                <th>Employer</th>
                                <th>Select</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(patientC, idx) in forUseInsurances" :key="idx">
                                <td>{{ patientC.customerInsuranceId }}</td>
                                <td>{{ patientC.organization }}</td>
                                <td></td>
                                <td>{{ patientC.memberno }}</td>
                                <td>{{ patientC.principalOfDependant }}</td>
                                <td>{{ patientC.memberIDNo }}</td>
                                <td>{{ patientC.notes }}</td>
                                <td>{{ patientC.rebate }}</td>
                                <td>{{ patientC.employer }}</td>
                                <td>
                                    <button class="btn-sm btn-primary text-xs" @click.prevent="patientCover.confirm = true"><i class="fa fa-check"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
          <div class="flex w-full">
              <div class="md:w-1/2 sm:w-full flex justify-center">
                  <button class="btn-warning btn-sm text-sm" @click.prevent="$emit('cashSelected')">Leave for cash</button>
              </div>
              <div class="md:w-1/2 sm:w-full flex justify-center">
                  <button class="btn-info btn-sm text-sm"><i class="fa fa-save"></i> Save / Close</button>
              </div>
          </div>
      </template>
    </tail-modal>
</template>
